import { Integration } from 'signup-constants/Integration';
import { AppName } from 'signup-ui-lego-core/constants/AppName';
import { getIntegrationKey } from '../routing/getIntegrationKey';
import { isIntegrationValid } from 'signup-ui-lego-core/utils/isIntegrationValid';
import { ConvertGoalType } from '../convert/ConvertGoalType';
import { DefaultFlowOptions } from '../flow-initial/FlowOptions';
import { SignupApiFlowPath } from '../http-clients/SignupApiFlowPath';
import { ViaParam } from '../intents/ViaParam';
import { getHasWordpressAuthSucceeded } from '../store/integrations/selectors';
export const defaultIntegrationsFlowOptions = Object.assign({}, DefaultFlowOptions, {
  appName: AppName.Integrations,
  viaParam: ViaParam.IntegrationsSignup
});
const FlowOptionsByIntegration = {
  [Integration.Shopify]: defaultIntegrationsFlowOptions,
  [Integration.Typeform]: defaultIntegrationsFlowOptions,
  [Integration.Wpforms]: defaultIntegrationsFlowOptions,
  [Integration.Wordpress]: Object.assign({}, defaultIntegrationsFlowOptions, {
    shouldShowBoxAccountCard: true,
    shouldShowTitleOnExistingUserView: true,
    shouldShowSignInButton: false,
    signupApiFlowPath: SignupApiFlowPath.Wordpress,
    appName: AppName.Wordpress,
    convertGoal: {
      [ConvertGoalType.SignupInitiated]: '100314458',
      [ConvertGoalType.SignupCompleted]: '10038690',
      [ConvertGoalType.ExistingUser]: '100314459'
    },
    canRedirect: state => getHasWordpressAuthSucceeded(state)
  })
};
export const getIntegrationFlowOptions = () => {
  const integrationKey = getIntegrationKey();

  if (!integrationKey || !isIntegrationValid(integrationKey)) {
    return defaultIntegrationsFlowOptions;
  }

  return FlowOptionsByIntegration[integrationKey];
};